module.exports = __webpack_public_path__ + "static/media/WEB11.634c2d49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/WEB11.jpg
// module id = 84
// module chunks = 0